import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router, NavigationEnd, ActivationStart, NavigationCancel } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { HeaderService } from '../../shared/_services/header.service';
import { SearchSchede } from '../../shared/_resolver/card-list.resolver';
import { ApiService } from '../../shared/_services/api.service';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';
import { StorageService } from '../../../app/shared/_services/storage.service';

@Component({
  selector: 'app-pagina-non-trovata',
  templateUrl: './pagina-non-trovata.component.html',
  styles: []
})
export class PaginaNonTrovataComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }


}
